import * as ActionTypes from "./types";

export function fetchApiProducts(payload) {
  return {
    type: ActionTypes.FETCH_API_PRODUCTS,
    payload,
  };
}

export function storeApiProducts(payload) {
  return {
    type: ActionTypes.STORE_API_PRODUCTS,
    payload,
  };
}
